/* eslint-disable react/jsx-pascal-case */
import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@material-ui/core/styles";
import { BaseURL, fetchTimeout, toNumber, toAUD } from "../../components/Common";
import FrameAppBar from "./FrameAppBar";
import { API_BASE, MANUFACTURER } from "../../AppConfig";
import * as PaperFunctions from "../../components_designer/layout/PaperFunctions";
import * as BSL_Common from "../../components/BSL_CommonControls";
import BSL_TextInput from "../../components/BSL_TextInput";
import BSL_Button from "../../components/BSL_Button";
import Message from "../../components/Message";
import {
    UPDATE_QUOTE_PARAMETERS,
    updateJobState,
    UPDATE_SITE_PARAMETERS,
    updateJobParameter,
    addNote,
} from "../../redux_store/jobState";
import BSL_DatePicker from "../../components/BSL_DatePicker";
import { Backdrop, CircularProgress, Paper, Typography } from "@material-ui/core";
import { GenerateSummaryRaw } from "../../components_designer/main_drawer/QuotePage";
import AttachFileIcon from "@material-ui/icons/AttachFile";
import { IconButton } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { SHOW_DESIGNER_MESSAGE } from "../../redux_store/appState";
import { compareItemLists } from "./OrderJobFunctions";
import { printing_rule_failed } from "../../helper/Report";

const { convertJobStateToIni } = require("../../components/Common_Conversions");

function bytesToSize(bytes) {
    var sizes = ["Bytes", "KB", "MB", "GB", "TB"];
    if (bytes == 0) return "0 Byte";
    var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
    return Math.round(bytes / Math.pow(1024, i), 2) + " " + sizes[i];
}

const useStyles = makeStyles({
    root: {
        width: "100%",
        height: "100%",
        background: "#EFEFEF",
    },
    content: {
        width: "100%",
        height: "100%",
        padding: "16px",
        paddingBottom: "80px",
        overflow: "auto",
    },
    order_paper: {},
    attachmentLabel: {
        alignSelf: "center",
        fontSize: "10pt",
        flex: 1,
        textAlign: "start",
        display: "flex",
        flexFlow: "wrap",
    },
    attachmentItem: {
        background: "#e7e794",
        borderRadius: "14px",
        padding: "0px 10px",
        whiteSpace: "nowrap",
        margin: "2px",
        display: "flex",
        alignItems: "center",
    },
    deleteButton: {
        fontSize: "0.5rem",
        padding: "0px",
    },
    itemRow: {
        display: "flex",
        width: "100%",
    },
    itemQty: {
        flex: 1,
        wordWrap: "break-word",
        whiteSpace: "normal",
    },
    itemDesc: {
        flex: 12,
        wordWrap: "break-word",
        whiteSpace: "normal",
    },
    itemCode: {
        flex: 4,
        wordWrap: "break-word",
        whiteSpace: "normal",
    },
    itemLength: {
        flex: 2,
        wordWrap: "break-word",
        whiteSpace: "normal",
    },
    itemColour: {
        flex: 3,
        wordWrap: "break-word",
        whiteSpace: "normal",
    },
});

export default function OrderJobPanel(props) {
    const classes = useStyles();
    const dispatch = useDispatch();
    const job = useSelector((state) => state.job);
    const config = useSelector((state) => state.config);
    const app = useSelector((state) => state.app);
    const user = app.user;
    const inputRef = React.useRef(null);
    const [showMessage, setShowMessage] = React.useState(false);
    const [messageText, setMessageText] = React.useState("");
    const [convertedOrderList, setConvertedOrderList] = React.useState(false);
    const [convertedSystemList, setConvertedSystemList] = React.useState(false);
    const [thumbData, setThumbData] = React.useState("");
    const [confirming, setConfirming] = React.useState(false);
    const [attachedFileForUpload, setAttachedFileForUpload] = React.useState([]);

    let manufacturer = useSelector((state) => state.app.manufacturer);
    if (window.LYSAGHT) {
        manufacturer = {
            ...MANUFACTURER.Lysaght,
            Logo: BaseURL(MANUFACTURER.Lysaght.Logo),
            logo_base64: MANUFACTURER.Lysaght.logo_base64,
            BrandColour: MANUFACTURER.Lysaght.BrandColour,
        };
    } else {
        manufacturer = {
            ...MANUFACTURER.Fielders,
            Logo: BaseURL(MANUFACTURER.Fielders.Logo),
            logo_base64: MANUFACTURER.Fielders.logo_base64,
            BrandColour: MANUFACTURER.Fielders.BrandColour,
        };
    }

    let job_ini = convertJobStateToIni(job, app, "", config);
    let material_list = job?.QuoteParameters?.BOM?.OrderList;
    let is_Custom_list = true;

    if (!material_list || !material_list?.items) {
        material_list = job?.QuoteParameters?.BOM?.SystemList;
        is_Custom_list = false;
    }

    let summary_template_row = `
<tr class="${classes.itemRow}">
    <td class="${classes.itemQty}">$$_QTY_$$ x </td>
    <td class="${classes.itemDesc}">$$_DESC_$$</td>
    <td class="${classes.itemCode}">$$_CODE_$$</td>
    <td class="${classes.itemLength}">$$_LENGTH_$$</td>
    <td class="${classes.itemColour}">$$_COLOUR_$$</td>
</tr>
`;

    React.useEffect(() => {
        if (!thumbData) {
            let thumb_data = "";
            try {
                PaperFunctions.zoomAll();
                thumb_data = window.paper_canvas.toDataURL();
                setThumbData(thumb_data);
            } catch {}
        }
    }, [thumbData]);

    React.useEffect(() => {
        if (!convertedOrderList) {
            let api_url = API_BASE() + "Order/CreateSummary";
            fetchTimeout(api_url, {
                method: "POST",
                body: JSON.stringify({
                    job_raw: job,
                    job: job_ini,
                    order_list: material_list,
                    user: user,
                }),
            })
                .then((response) => response.json())
                .then((json) => {
                    setConvertedOrderList(json);
                })
                .catch((e) => {
                    setConvertedOrderList(false);
                });
        }
    }, [convertedOrderList]);

    React.useEffect(() => {
        if (job?.QuoteParameters?.BOM?.OrderList?.items) {
            if (!convertedSystemList) {
                let api_url = API_BASE() + "Order/CreateSummary";
                fetchTimeout(api_url, {
                    method: "POST",
                    body: JSON.stringify({
                        job_raw: job,
                        job: job_ini,
                        order_list: job?.QuoteParameters?.BOM?.SystemList,
                        user: user,
                    }),
                })
                    .then((response) => response.json())
                    .then((json) => {
                        setConvertedSystemList(json);
                    })
                    .catch((e) => {
                        setConvertedSystemList(false);
                    });
            }
        }
    }, [convertedSystemList]);

    let item_rows_HTML = "";
    if (convertedOrderList && convertedOrderList.length > 0) {
        for (let item of convertedOrderList) {
            let colour = item?.Colour ? item.Colour : "";
            let splitColour = colour.split("/");
            colour = splitColour[0] === splitColour[1] ? splitColour[0] : colour;

            item_rows_HTML += summary_template_row
                .replace("$$_QTY_$$", item?.Qty)
                .replace("$$_DESC_$$", item?.Desc)
                .replace("$$_CODE_$$", item?.Fielders_Code)
                .replace("$$_LENGTH_$$", toNumber(item?.Length) > 0 ? " @" + toNumber(item?.Length) + "mm" : "")
                .replace("$$_COLOUR_$$", colour);
        }
    }

    let added_item_rows_HTML = "None";
    let removed_item_rows_HTML = "None";

    if (convertedSystemList && convertedOrderList) {
        const diff = compareItemLists(convertedSystemList, convertedOrderList);

        if (diff?.addedItems.length > 0) {
            added_item_rows_HTML = "";
            for (let item of diff?.addedItems) {
                let colour = item?.Colour ? item.Colour : "";
                let splitColour = colour.split("/");
                colour = splitColour[0] === splitColour[1] ? splitColour[0] : colour;

                added_item_rows_HTML += summary_template_row
                    .replace("$$_QTY_$$", item?.Qty)
                    .replace("$$_DESC_$$", item?.Desc)
                    .replace("$$_CODE_$$", item?.Fielders_Code)
                    .replace("$$_LENGTH_$$", toNumber(item?.Length) > 0 ? " @" + toNumber(item?.Length) + "mm" : "")
                    .replace("$$_COLOUR_$$", colour);
            }
        }

        if (diff?.removedItems.length > 0) {
            removed_item_rows_HTML = "";
            for (let item of diff?.removedItems) {
                let colour = item?.Colour ? item.Colour : "";
                let splitColour = colour.split("/");
                colour = splitColour[0] === splitColour[1] ? splitColour[0] : colour;

                removed_item_rows_HTML += summary_template_row
                    .replace("$$_QTY_$$", item?.Qty)
                    .replace("$$_DESC_$$", item?.Desc)
                    .replace("$$_CODE_$$", item?.Fielders_Code)
                    .replace("$$_LENGTH_$$", toNumber(item?.Length) > 0 ? " @" + toNumber(item?.Length) + "mm" : "")
                    .replace("$$_COLOUR_$$", colour);
            }
        }
    }

    let attachments = [];
    let attachment_filenames = "";
    let combined_size = 0;

    if (attachedFileForUpload) {
        attachments = [...attachedFileForUpload];
        for (let item of attachments) {
            attachment_filenames +=
                (attachment_filenames !== "" ? "<br />" : "") + item.Filename + " (" + bytesToSize(item.size) + ")";
            combined_size += item.size;
        }
    }

    const materialListTotalPrice = material_list?.display_only_total_price
        ? material_list.display_only_total_price
        : material_list.total_eprice;

    let totalExGST = materialListTotalPrice + job.Distributor.DeliveryFee + job.Distributor.PackingFee;
    let GST = totalExGST * 0.1;
    let totalIncGST = totalExGST + GST;

    let summary = summary_template
        .replace("$$_ITEMS_ORDERED_$$", item_rows_HTML)
        .replace("$$_MATERIAL_ORDER_PRICE_$$", toAUD(materialListTotalPrice))
        .replace("$$_DELIVERY_FEE_$$", toAUD(job.Distributor.DeliveryFee))
        .replace("$$_PACKING_FEE_$$", toAUD(job.Distributor.PackingFee))
        .replace("$$_GST_$$", toAUD(GST))
        .replace("$$_TOTAL_PRICE$$", toAUD(totalIncGST))
        .replace("$$_ORDER_LIST_TYPE_$$", is_Custom_list ? "CUSTOMISED ORDER LIST" : "SYSTEM GENERATED LIST")
        .replace(
            "$$_ORDER_NOTES_$$",
            material_list?.price_error_summary
                ? "Error pricing the following items:<br />" +
                      material_list?.price_error_summary.replace(/(?:\r\n|\r|\n)/g, "<br>") +
                      "<br /> these have not been added to the price and may incur extra charges if ordered."
                : ""
        );

    let date_str = "NOT FOUND";
    if (material_list?.pricing_timestamp) {
        var date = new Date(material_list?.pricing_timestamp);
        date_str = date.toLocaleString();
    }

    summary = summary.replace("$$_PRICING_DATE_$$", date_str);
    let dist = job.Distributor.Name + "<br />";
    dist += job?.Distributor?.Email + " | " + job?.Distributor?.Phone;
    summary = summary.replace("$$_DISTRIBUTOR_$$", dist);
    let user_str =
        (job?.User?.DisplayName ? job?.User?.DisplayName : job?.User?.FirstName + " " + job?.User?.LastName) + "<br />";
    user_str += job?.User?.Email + " | " + job?.User?.Phone;
    summary = summary.replace("$$_USER_$$", user_str);

    let design_summary = "";
    if (job?.DesignSummary) {
        design_summary = job?.DesignSummary + "<br/>";
    }

    design_summary +=
        '<img src="cid:' +
        job.id +
        '.png"  width="100%" style="background: white; width: 100%; max-width: 900px;"><br/><hr/>';
    let summary_list = GenerateSummaryRaw(job, true);

    for (let item in summary_list) {
        design_summary += "<strong>" + item + "</strong>: " + summary_list[item] + "<br />";
    }

    summary = summary.replace("$$_DESIGN_SUMMARY_$$", design_summary);
    summary = summary.replace("$$_JOB_SITE_ADDRESS_$$", job.SiteParameters.Address.FormattedAddress);

    var delivery_date = new Date();
    delivery_date.setDate(delivery_date.getDate() + 7);

    if (job?.QuoteParameters?.DeliveryDate) {
        delivery_date = new Date(Date.parse(job?.QuoteParameters?.DeliveryDate));
    }

    summary = summary.replace(
        "$$_DELIVERY_DATE_$$",
        "Requested Delivery: " +
            delivery_date.toLocaleDateString("en-GB", {
                month: "2-digit",
                day: "2-digit",
                year: "numeric",
            })
    );
    summary = summary.replace("$$_DELIVERY_NOTES_$$", job.SiteParameters.DeliveryNotes);
    summary = summary.replace(
        "$$_ENGINEERING_$$",
        job?.QuoteParameters?.SupplementaryEngineering ? job?.QuoteParameters?.SupplementaryEngineering : ""
    );
    summary = summary.replace("$$_JOB_ID_$$", job.id + " (" + job.Customer.JobName + ")");
    summary = summary.replaceAll("$$_JOB_URL_$$", window.location.origin + BaseURL() + "?job=" + job.id);
    summary = summary.replace("$$_ATTACHMENTS_$$", attachment_filenames ? attachment_filenames : "None");
    summary = summary.replace("$$_ITEMS_ADDED_$$", added_item_rows_HTML);
    summary = summary.replace("$$_ITEMS_REMOVED_$$", removed_item_rows_HTML);

    let summary_email_HTML = summary;

    if (thumbData) {
        summary = summary.replace("cid:" + job.id + ".png", thumbData);
    }

    let header = header_template
        .replaceAll("cid:logo.png", manufacturer.logo_base64)
        .replaceAll("#192e61", manufacturer.BrandColour);

    let lyvesCode =
        job?.Customer?.DistLevel ?? job?.Distributor?.LYVESAccount ?? app?.user?.BusinessDetails?.LYVESAccount;

    const confirmOrder = () => {
        setConfirming(true);
        let api_url = API_BASE() + "Order/SendOrder";

        //add screenshot of paper
        let inline_attachments = [];

        try {
            // base64 encoded data doesn't contain commas
            let base64ContentArray = thumbData.split(",");

            // base64 content cannot contain whitespaces but nevertheless skip if there are!
            let mimeType = base64ContentArray[0].match(/[^:\s*]\w+\/[\w-+\d.]+(?=[;| ])/)[0];

            // base64 encoded data - pure
            let base64Data = base64ContentArray[1];

            inline_attachments.push({
                "Content-type": mimeType,
                Filename: job.id + ".png",
                size: base64Data.length,
                content: base64Data,
            });

            // base64 encoded data doesn't contain commas
            base64ContentArray = manufacturer.logo_base64.split(",");

            // base64 content cannot contain whitespaces but nevertheless skip if there are!
            mimeType = base64ContentArray[0].match(/[^:\s*]\w+\/[\w-+\d.]+(?=[;| ])/)[0];

            // base64 encoded data - pure
            base64Data = base64ContentArray[1];

            inline_attachments.push({
                "Content-type": "image/png",
                Filename: "logo.png",
                size: base64Data.length,
                content: base64Data,
            });
        } catch {}

        if (attachedFileForUpload) {
            if (combined_size > 2096000 * 4) {
                setShowMessage({
                    type: "Error",
                    message: "Error: Attached files are too large. Max size overall = 8MB",
                });
                setConfirming(false);
                return;
            } else if (combined_size > 2096000 * 2) {
                setShowMessage({
                    type: "warning",
                    message: "uploading attachments...",
                });
            }
        }

        let header = header_template
            .replaceAll("cid:logo.png", manufacturer.logo_base64)
            .replaceAll("#192e61", manufacturer.BrandColour);

        let html =
            header +
            `<br /><div style="
    font-size: 16px;
    color: #01507e;">` +
            messageText.replace(/(?:\r\n|\r|\n)/g, "<br>") +
            `</div><br />` +
            summary_email_HTML;

        console.log(
            JSON.stringify({
                FromEmail: window.LYSAGHT ? "no_reply@lysaght.com" : "no_reply@qikquotecentenary.comu",
                FromName: manufacturer.SoftwareName + " (No Reply)",
                Subject: "ORDER: #" + job.id + " (" + job.Customer.JobName + ")",
                TextPart: messageText,
                HtmlPart: html,
                To:
                    '"' +
                    config.region.name +
                    '" <' +
                    (window.debug ? "centsupport@qikquotecentenary.com" : config.region.support_email) +
                    ">",
                CC:
                    '"' +
                    (user?.DisplayName
                        ? user?.DisplayName
                        : user.FirstName + (user.LastName ? " " + user.LastName : "")) +
                    '" <' +
                    user.Email +
                    ">",
                Attachments: attachments,
                InlineAttachments: inline_attachments,
                job: job,
            })
        );

        let username = user?.DisplayName
            ? user?.DisplayName
            : user.FirstName + (user.LastName ? " " + user.LastName : "");

        fetchTimeout(
            api_url,
            {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    FromEmail: window.LYSAGHT ? "no_reply@lysaght.com" : "no_reply@qikquotecentenary.com",
                    FromName: manufacturer.SoftwareName + " (No Reply)",
                    Subject: "ORDER: #" + job.id + " " + lyvesCode + " (" + job.Customer.JobName + ")",
                    TextPart: messageText,
                    HtmlPart: html,
                    To:
                        '"' +
                        config.region.name +
                        '" <' +
                        (window.debug ? "centsupport@qikquotecentenary.com" : config.region.support_email) +
                        ">",
                    CC: '"' + username + '" <' + user.Email + ">",
                    Attachments: attachments,
                    InlineAttachments: inline_attachments,
                    job: job,
                }),
            },
            60000
        )
            .then(async (response) => {
                if (window.debug || (response.status >= 200 && response.status <= 300)) {
                    setShowMessage({
                        type: "Success",
                        message: "Success: Order Emails sent",
                    });
                    dispatch(
                        updateJobParameter(null, {
                            Status: "Ordered",
                            OrderStatus: "PENDING",
                            OrderTimestamp: new Date().getTime(),
                            OrderBy: username,
                            OrderListIsCustom: is_Custom_list,
                        })
                    );
                    dispatch(addNote(true, user, "Job Ordered - Pending Order Check"));

                    dispatch({
                        type: SHOW_DESIGNER_MESSAGE,
                        message: {
                            type: "Success",
                            message: "Success: Order Emails sent",
                        },
                    });

                    setConfirming(false);
                    props.toggleOpen();
                } else {
                    setShowMessage({
                        type: "error",
                        message: "Error sending ORDER request. Please try again.",
                    });

                    setConfirming(false);
                }
            })
            .catch((e) => {
                setShowMessage({
                    type: "error",
                    message: "Possible Error sending ORDER request. Please check your email to see if it was sent.",
                });
                setConfirming(false);
            });
    };

    const deleteAttachment = (index) => {
        let newattachedFileForUpload = [...attachedFileForUpload];
        newattachedFileForUpload.splice(index, 1);
        setAttachedFileForUpload(newattachedFileForUpload);
    };

    const uploadFile = (e) => {
        if (!inputRef?.current?.files) return;
        if (inputRef.current.files[0].size > 2096000 * 2) {
            setShowMessage({
                type: "warning",
                message: "Error: File is too large to attach. Max size = 4MB",
            });
            return;
        }

        var FR = new FileReader();

        FR.addEventListener("load", function (e2) {
            if (!inputRef?.current?.files) return;

            var data = e2.target.result;

            // base64 encoded data doesn't contain commas
            let base64ContentArray = data.split(",");

            // base64 content cannot contain whitespaces but nevertheless skip if there are!
            let mimeType = base64ContentArray[0].match(/[^:\s*]\w+\/[\w-+\d.]+(?=[;| ])/)[0];

            // base64 encoded data - pure
            let base64Data = base64ContentArray[1];

            let newattachedFileForUpload = [...attachedFileForUpload];
            newattachedFileForUpload.push({
                "Content-type": mimeType,
                Filename: inputRef.current.files[0].name,
                size: inputRef.current.files[0].size,
                content: base64Data,
            });
            setAttachedFileForUpload(newattachedFileForUpload);
            inputRef.current.value = "";
        });

        FR.readAsDataURL(e.target.files[0]);
    };

    const printing_failed = printing_rule_failed({ job, config });

    return (
        <div className={classes.root}>
            <FrameAppBar
                title="ORDER JOB"
                onClick={props.toggleOpen}
                button1Text={printing_failed ? "LOCKED - " + printing_failed : "CONFIRM ORDER"}
                button1Click={confirmOrder}
                disabled={printing_failed || job?.DOrderStatus != null}
            />

            <div className={classes.content}>
                <BSL_Common.SectionContainer>
                    <BSL_Common.SectionRow>
                        <Paper style={{ width: "100%", padding: "10px" }}>
                            <BSL_Common.SectionSubHeader>
                                <strong>to:</strong> {config.region.name} {"<"}
                                {window.debug ? "centsupport@qikquotecentenary.com" : config.region.support_email}
                                {">"}
                                <br />
                                <strong>cc:</strong>{" "}
                                {user?.DisplayName
                                    ? user?.DisplayName
                                    : user.FirstName + (user.LastName ? " " + user.LastName : "")}{" "}
                                {"<"}
                                {user.Email}
                                {">"}
                                <br />
                                <strong>subject:</strong> ORDER: #{job.id} {lyvesCode} ({job.Customer.JobName})
                            </BSL_Common.SectionSubHeader>

                            <div dangerouslySetInnerHTML={{ __html: header }} />

                            <BSL_Common.SectionRow>
                                <BSL_DatePicker
                                    label="Preferred Delivery Date"
                                    disableForwardDays={14} // 2 Weeks minimum delivery date.
                                    tight
                                    disabled={job?.DOrderStatus != null}
                                    value={job?.QuoteParameters?.DeliveryDate}
                                    onChange={(date) => {
                                        // Convert date to a string in the desired format without timezone info
                                        const formattedDate = date ? date.toISOString().split("T")[0] : null; // This will give you "YYYY-MM-DD"
                                        dispatch(
                                            updateJobState(UPDATE_QUOTE_PARAMETERS, "DeliveryDate", formattedDate)
                                        );
                                    }}
                                    style={{ width: "240px", flex: "none" }}
                                />

                                <BSL_TextInput
                                    label="Site/Delivery Notes"
                                    tight
                                    multiline
                                    value={job?.SiteParameters?.DeliveryNotes}
                                    rows={2}
                                    style={{
                                        flex: 1,
                                    }}
                                    onBlur={(val) => {
                                        dispatch(updateJobState(UPDATE_SITE_PARAMETERS, "DeliveryNotes", val));
                                    }}
                                />
                            </BSL_Common.SectionRow>

                            <BSL_TextInput
                                label="Order Comments"
                                multiline
                                tight
                                value={messageText}
                                rows={4}
                                style={{
                                    flex: 1,
                                }}
                                onBlur={(val) => {
                                    setMessageText(val);
                                }}
                            />

                            <BSL_Common.SectionRow>
                                <input
                                    ref={inputRef}
                                    key={"input_upload_order"}
                                    accept=".pdf, .png, .jpg, .jpeg, .gif, .doc, .docx, .xls, .xlsx"
                                    style={{ display: "none" }}
                                    id="order_attachment"
                                    multiple
                                    type="file"
                                    onChange={uploadFile}
                                />
                                <label htmlFor="order_attachment">
                                    <BSL_Button
                                        secondary
                                        variant="contained"
                                        component="span"
                                        label={<AttachFileIcon />}
                                    />
                                </label>
                                <div className={classes.attachmentLabel}>
                                    {attachedFileForUpload.map((item, index) => {
                                        return (
                                            <div className={classes.attachmentItem}>
                                                <span style={{ flex: 1 }}>
                                                    {item.Filename + " (" + bytesToSize(item.size) + ")"}
                                                </span>
                                                <IconButton
                                                    className={classes.deleteButton}
                                                    onClick={() => deleteAttachment(index)}
                                                >
                                                    <CloseIcon />
                                                </IconButton>
                                            </div>
                                        );
                                    })}
                                </div>
                            </BSL_Common.SectionRow>

                            <div dangerouslySetInnerHTML={{ __html: summary }} style={{ padding: "0px 10px" }} />
                        </Paper>
                    </BSL_Common.SectionRow>
                </BSL_Common.SectionContainer>
            </div>

            {confirming && (
                <Backdrop
                    style={{
                        zIndex: 10100,
                        color: "#fff",
                    }}
                    open={confirming}
                >
                    <CircularProgress color="inherit" style={{ position: "absolute" }} />
                    <br />
                    <Typography variant="overline" gutterBottom style={{ marginTop: "100px" }}>
                        CONFIRMING ORDER...
                    </Typography>
                </Backdrop>
            )}
            <Message
                open={showMessage}
                message={showMessage?.message}
                type={showMessage?.type}
                onClose={() => setShowMessage(null)}
            />
        </div>
    );
}

var header_template = `<div style="width: 100%; padding: 7px; padding-top: 12px; padding-left: 40px; background: #192e61"><img src=\"cid:logo.png\" style=\"height: 32px;\"></div>`;

var summary_template = `
<h3 style="
  font-size: 21px;
  color: #01507e;
  margin: 20px 0 20px;
  font-family: "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-weight: 200;
  text-align: left;
">JOB SUMMARY</h3>
<table style="border-collapse: collapse; width: 100%; max-width: 900px" border="1" cellpadding="5px">
<tbody>
<tr style="height: 16px;">
<td style="vertical-align: top; width: 160px; font-size: 10pt; font-weight:600; background-color: rgba(221, 229, 236, 0.86);">DISTRIBUTOR</td>
<td style="font-size: 10pt;">$$_DISTRIBUTOR_$$</td>
</tr>
<tr style="height: 16px;">
<td style="vertical-align: top; width: 160px; font-size: 10pt; font-weight:600; background-color: rgba(221, 229, 236, 0.86);">USER / CONTACT</td>
<td style="font-size: 10pt;">$$_USER_$$</td>
</tr>
<tr style="height: 16px;">
<td style="vertical-align: top; width: 160px; font-size: 10pt; font-weight:600; background-color: rgba(221, 229, 236, 0.86);">JOB SITE ADDRESS</td>
<td style="font-size: 10pt;">$$_JOB_SITE_ADDRESS_$$
</tr>
<tr style="height: 16px;">
<td style="width: 160px; font-size: 10pt; font-weight:600; background-color: rgba(221, 229, 236, 0.86);">JOB ID / LINK</td>
<td style="font-size: 10pt;">$$_JOB_ID_$$<br /><a href="$$_JOB_URL_$$" target="_blank">$$_JOB_URL_$$</a></td>
</tr>
<tr style="height: 16px;">
<td style="vertical-align: top; width: 160px; font-size: 10pt; font-weight:600; background-color: rgba(221, 229, 236, 0.86);">DELIVERY NOTES</td>
<td style="font-size: 10pt;">$$_DELIVERY_DATE_$$<br />Notes: $$_DELIVERY_NOTES_$$
</tr>
<tr style="height: 16px;">
<td style="vertical-align: top; width: 160px; font-size: 10pt; font-weight:600; background-color: rgba(221, 229, 236, 0.86);">DESIGN_SUMMARY</td>
<td style="font-size: 10pt;">$$_DESIGN_SUMMARY_$$<br/>
</tr>
<tr style="height: 16px;">
<td style="vertical-align: top; width: 160px; font-size: 10pt; font-weight:600; background-color: rgba(221, 229, 236, 0.86);">SUPPLEMENTARY ENGINEERING</td>
<td style="font-size: 10pt;">$$_ENGINEERING_$$<br/>
</tr>
<tr style="height: 16px;">
<td style="width: 160px; font-size: 10pt; font-weight:600; background-color: rgba(221, 229, 236, 0.86);">ATTACHMENTS</td>
<td style="font-size: 10pt;">$$_ATTACHMENTS_$$</td>
</tr>
</tbody>
</table>
<h3 style="
  font-size: 21px;
  color: #01507e;
  margin: 40px 0 20px;
  font-family: "Open Sans", "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-weight: 200;
  text-align: left;
">ORDER LIST SUMMARY</h3>
<table style="border-collapse: collapse; width: 100%; max-width: 900px" border="1" cellpadding="5px">
<tbody>
<tr style="height: 16px;">
<td style="vertical-align: top; width: 160px; font-size: 10pt; font-weight:600; background-color: rgba(221, 229, 236, 0.86);">TOTAL SUPPLY PRICE</td>
<td style="font-size: 10pt;">$$_MATERIAL_ORDER_PRICE_$$ (ex GST) + Packing and Del<br/></td>
</tr>
<tr style="height: 16px;">
<td style="vertical-align: top; width: 160px; font-size: 10pt; font-weight:600; background-color: rgba(221, 229, 236, 0.86);">PACKING, DELIVERY & GST<br/></td>
<td style="font-size: 10pt;">
  <table style="width: 100%; border: none; border-collapse: collapse;">
    <tr>
      <td style="width: 100px; text-align: left; border: none;">Delivery:</td>
      <td style="text-align: left; border: none;">$$_DELIVERY_FEE_$$</td>
    </tr>
    <tr>
      <td style="width: 100px; text-align: left; border: none;">Packing:</td>
      <td style="text-align: left; border: none;">$$_PACKING_FEE_$$</td>
    </tr>
    <tr>
      <td style="width: 100px; text-align: left; border: none;">GST:</td>
      <td style="text-align: left; border: none;">$$_GST_$$</td>
    </tr>
  </table>
</td>
</tr>
<tr style="height: 16px;">
<td style="vertical-align: top; width: 160px; font-size: 10pt; font-weight:600; background-color: rgba(221, 229, 236, 0.86);">TOTAL PRICE</td>
<td style="font-size: 10pt;">$$_TOTAL_PRICE$$  (Total Supply Price + Packing + Delivery + GST)<br/><br/></td>
</tr>
<tr style="height: 16px;">
<td style="vertical-align: top; width: 160px; font-size: 10pt; font-weight:600; background-color: rgba(221, 229, 236, 0.86);">ORDER LIST TYPE</td>
<td style="font-size: 10pt;"><table style="border-collapse: collapse; width: 100%" border="0" cellpadding="5px">$$_ORDER_LIST_TYPE_$$</table></td>
</tr>
<tr style="height: 16px;">
<td style="vertical-align: top; width: 160px; font-size: 10pt; font-weight:600; background-color: rgba(221, 229, 236, 0.86);">ORDER LIST NOTES</td>
<td style="font-size: 10pt;"><table style="border-collapse: collapse; width: 100%" border="0" cellpadding="5px">$$_ORDER_NOTES_$$</table></td>
</tr>
<tr style="height: 16px;">
<td style="vertical-align: top; width: 160px; font-size: 10pt; font-weight:600; background-color: rgba(221, 229, 236, 0.86);">ITEMS ORDERED</td>
<td style="font-size: 10pt;"><table style="border-collapse: collapse; width: 100%" border="0" cellpadding="5px">$$_ITEMS_ORDERED_$$</table></td>
</tr>
</tr>
<tr style="height: 16px;">
<td style="vertical-align: top; width: 160px; font-size: 10pt; font-weight:600; background-color: rgba(221, 229, 236, 0.86);">ITEMS ADDED</td>
<td style="font-size: 10pt;"><table style="border-collapse: collapse; width: 100%" border="0" cellpadding="5px">$$_ITEMS_ADDED_$$</table></td>
</tr>
</tr>
<tr style="height: 16px;">
<td style="vertical-align: top; width: 160px; font-size: 10pt; font-weight:600; background-color: rgba(221, 229, 236, 0.86);">ITEMS REMOVED</td>
<td style="font-size: 10pt;"><table style="border-collapse: collapse; width: 100%" border="0" cellpadding="5px">$$_ITEMS_REMOVED_$$</table></td>
</tr>
<tr style="height: 16px;">
<td style="vertical-align: top; width: 160px; font-size: 10pt; font-weight:600; background-color: rgba(221, 229, 236, 0.86);">PRICING DATE</td>
<td style="font-size: 10pt;">$$_PRICING_DATE_$$</td>
</tr>
</tbody>
</table>
<p><span style="color: #999999;" class="hidden"><em>this email was sent from a no-reply email address, however this email has been CC'd to the requester, so you may "Reply All' to communicate directly via email with the requester.</em></span></p>`;
